import angular from 'angular';

import { createStore, compose, combineReducers, applyMiddleware } from 'redux';

import digestMiddleware from './middlewares/digest.middleware.js';

import boundsToHighlight from './reducers/bounds-to-highlight.reducer';
import mapBounds from './reducers/map-bounds.reducer';
import mapReady from './reducers/map-ready.reducer';
import pointMapToCoordinates from './reducers/point-map-to-coordinates.reducer';
import searchedPlaceCoordinates from './reducers/searched-place-coordinates.reducer';
import setClickedShopMarkerCoordinates from './reducers/set-clicked-shop-marker-coordinates.reducer';
import shopAppointmentIntervals from './reducers/shop-appointment-intervals.reducer';
import shopAppointmentReasons from './reducers/shop-appointment-reasons.reducer';
import shopMarkersReady from './reducers/shop-markers-ready.reducer';
import shopsInBounds from './reducers/shops-in-bounds.reducer';
import shopType from './reducers/shop-type.reducer';
import toggleInfoWindow from './reducers/toggle-info-window.reducer';
import triggerClickOnMarker from './reducers/trigger-click-on-marker.reducer';

let combinedReducers = combineReducers({
    boundsToHighlight,
    mapBounds,
    mapReady,
    pointMapToCoordinates,
    searchedPlaceCoordinates,
    setClickedShopMarkerCoordinates,
    shopAppointmentIntervals,
    shopAppointmentReasons,
    shopMarkersReady,
    shopsInBounds,
    shopType,
    toggleInfoWindow,
    triggerClickOnMarker
});

var storeProvider = function() {

    this.$get = function($injector) {

        return createStore(
            combinedReducers, {},
            compose(
                window.devToolsExtension ? window.devToolsExtension() : f => f,
                applyMiddleware(
                    digestMiddleware(
                        $injector.get('$rootScope'),
                        $injector.get('$timeout')
                    )
                )
            )
        );
    };

    this.$get.$inject = ['$injector'];
};

export default angular.module('app.store', [])
    .provider('storeServ', storeProvider)
    .name;